import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@sakhtar/design-system/components.css';
// V2 visual system (Sakhtar Design System V2, live Claude Design authority)
// — additive, `.sk-app`/`.sk-frame`-scoped, `--sk-*` namespaced. See
// packages/design-system/src/tokens/v2/colors.ts for why this coexists
// with components.css above rather than replacing it.
import '@sakhtar/design-system/v2.css';
import './shell/mobileOverlays.css';
import './shell/safeArea.css';
import { App } from './App.js';

import { registerPwaServiceWorker } from './lib/pushNotifications.js';

// Auto-register Service Worker for PWA Add-to-Home-Screen push notifications
if (typeof window !== 'undefined') {
  void registerPwaServiceWorker();
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root element missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
